/** Blue Phoenix logo — uses the real phoenix mark from /brand/phoenix.png */

export function PhoenixMark({ size = 36, className = "" }) {
    return (
        <img
            src="/brand/phoenix.png"
            alt="Blue Phoenix"
            width={size}
            height={size}
            className={`select-none ${className}`}
            style={{ width: size, height: size, objectFit: "contain" }}
            draggable={false}
        />
    );
}

export function PhoenixWordmark({ subtitle = false, size = 38, className = "" }) {
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <PhoenixMark size={size} />
            <div className="leading-none">
                <div className="font-display font-bold text-lg text-phoenix-navy tracking-tight">
                    Blue Phoenix
                </div>
                {subtitle && (
                    <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-1">
                        Mental health · rehabilitation
                    </div>
                )}
            </div>
        </div>
    );
}
